// import Vue from 'vue'

const actions = {
  setCopiedPlaylistitemDaytimeRestrictions (context, restrictions) {
    context.commit('SET_COPIED_PLAYLISTITEM_DAYTIME_RESTRICTIONS', restrictions)
  },
  setCopiedPlaylistitemDateRestrictions (context, restrictions) {
    context.commit('SET_COPIED_PLAYLISTITEM_DATE_RESTRICTIONS', restrictions)
  },
  setCopiedDeviceDaytimeRestrictions (context, restrictions) {
    context.commit('SET_COPIED_DEVICE_DAYTIME_RESTRICTIONS', restrictions)
  },
  setCopiedDeviceDateRestrictions (context, restrictions) {
    context.commit('SET_COPIED_DEVICE_DATE_RESTRICTIONS', restrictions)
  },
  setCopiedMediaTags (context, tags) {
    context.commit('SET_COPIED_MEDIA_TAGS', tags)
  },
  setCopiedDeviceTagsPlayDependency (context, value) {
    context.commit('SET_COPIED_DEVICE_TAGS_PLAY_DEPENDENCY', value)
  },
  setCopiedDeviceTags (context, tags) {
    context.commit('SET_COPIED_DEVICE_TAGS', tags)
  },
  setCopiedLocalPlayItems (context, playitems) {
    context.commit('SET_COPIED_LOCAL_PLAYITEMS', playitems)
  },
  setCopiedPlayerExceptions (context, playitem) {
    context.commit('SET_COPIED_PLAYER_EXCEPTIONS', playitem)
  },
  setCopiedPlayProperties (context, playitem) {
    context.commit('SET_COPIED_PLAY_PROPERTIES', playitem)
  },
  setCopiedSynchroListener (context, playitem) {
    context.commit('SET_COPIED_SYNCRO_LISTENER', playitem)
  }
}
export default actions



//////////////////
// WEBPACK FOOTER
// ./state/clipboard/clipboard.actions.js
// module id = null
// module chunks = 